import { render } from "./StockTransferDetail.vue?vue&type=template&id=288c724e&scoped=true"
import script from "./StockTransferDetail.vue?vue&type=script&lang=js"
export * from "./StockTransferDetail.vue?vue&type=script&lang=js"

import "./StockTransferDetail.vue?vue&type=style&index=0&id=288c724e&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288c724e"]])

export default __exports__